import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import api from "../../services/apiService";
import {
    Grid, Box, Typography, Button, Paper, Link
} from "@material-ui/core";

const ImportacaoDados = () => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);


    const onFileChange = (event) => {
        setFile(event.target.files[0]);
    };

    const uploadFile = async (presignedPostData, file) => {
        const formData = new FormData();
    
        Object.keys(presignedPostData.fields).forEach(key => {
            formData.append(key, presignedPostData.fields[key]);
        });

        formData.append('file', file);

        const result = await axios({
            method: 'post',
            url: presignedPostData.url,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

        return result.data;
    }

    const onUpload = async () => {
        if (!file) return;
    
        try {
            setUploading(true);
    
            // Solicite a URL pré-assinada do backend
            const response = await api.post(`/empresa/dados-internos`, { filename: file.name });
            const { url, fields } = response.data.response;
    
            // Use a função uploadFile para enviar o arquivo
            await uploadFile({ url, fields }, file);
            
            toast.success('Arquivo enviado com sucesso!');
    
        } catch (error) {
            console.error("Erro no upload:", error);
            toast.error('Erro ao enviar o arquivo.');
        } finally {
            setUploading(false);
        }
    };
    
    return (
        <Grid container direction="row" alignItems="center" justifyContent="center">
            <Box marginTop="2rem" width="80rem" maxWidth="95vw">
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography variant="h6">
                            <Box fontWeight="bold">
                                Importar Arquivos
                            </Box>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper elevation={3} style={{ padding: '20px' }}>
                            <Typography variant="h6" style={{ marginBottom: '10px' }}>
                                Dados da Importação
                            </Typography>
                            <Typography variant="body1" style={{ marginBottom: '20px', fontSize: '12px' }}>
                                Arquivo *
                            </Typography>
                            <input 
                                type="file" 
                                onChange={onFileChange} 
                                style={{ display: 'none' }} 
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                                id="upload-button-file" 
                            />
                            <label htmlFor="upload-button-file">
                                <Button component="span" variant="contained" color="primary">
                                    Selecione o arquivo
                                </Button>
                            </label>
                            <Typography variant="body2" style={{ marginBottom: '20px' }}>
                            <Link href={process.env.REACT_APP_S3_URL_MODELO_DADOS_INTERNOS} target="_blank" rel="noopener noreferrer">
                                Baixar arquivo modelo
                            </Link>
                            </Typography>
                            <Button 
                                onClick={onUpload} 
                                disabled={uploading} 
                                variant="contained" 
                                color="secondary" 
                                style={{ marginLeft: '10px' }}
                            >
                                {uploading ? 'Enviando...' : 'Enviar'}
                            </Button>
                        </Paper>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default ImportacaoDados;
